import { useGetList } from 'react-admin';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { TableCellRight } from './TableCellRight';
import ItemName from './ItemName';

const Basket = ({ record }: any) => {
    if (!record?.orderItems?.length) return null;

    const orderItems = record.orderItems;

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Item</TableCell>
                    <TableCellRight>Tracking ID</TableCellRight>
                    <TableCellRight>Amount</TableCellRight>
                    <TableCellRight>Date</TableCellRight>
                    <TableCellRight>Total</TableCellRight>
                </TableRow>
            </TableHead>
            <TableBody>
                {orderItems.map((item: any) => {
                    const amount = Number(item.amount) || 0;
                    const discount = Number(item.discount) || 0;
                    const delivery = Number(item.deliveryAmount) || 0;
                    const total = amount - discount + delivery;

                    return (
                        <TableRow key={item.id}>
                            <TableCell>
                                <ItemName productId={item.productId} />
                            </TableCell>

                            <TableCellRight>{record?.trackingId}</TableCellRight>

                            <TableCellRight>₹{amount}</TableCellRight>

                            <TableCellRight>
                                {new Date(item.createdAt).toLocaleString()}
                            </TableCellRight>

                            <TableCellRight>₹{total}</TableCellRight>
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    );
};

export default Basket;
